<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-title">如鉴黄金</div>
      <div class="footer-content">
        <div class="footer-left">
          COPYRIGHT©2025<span
            style="padding: 0 4px"
            @click="toUrl('http://www.goldenl.cn')"
            >www.goldenl.cn</span
          >
          <span @click="toUrl('https://beian.miit.gov.cn')"
            >蜀ICP备2025153612号-1</span
          >
        </div>
        <div class="footer-right">
          <img class="img" src="@/assets/img/home-icon1.png" />
          <img class="img" src="@/assets/img/home-icon2.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const toUrl = (url) => {
  window.open(url);
};
</script>

<style lang="less" scoped>
.footer {
  width: 100vw;
  padding: 58px 0;
  box-sizing: border-box;
  border-top: 1px solid #e6e6e6;

  .footer-container {
    width: 75%;
    margin: 0 auto;

    .footer-title {
      font-weight: 400;
      font-size: 26px;
      color: #242424;
      padding-bottom: 26px;
      box-sizing: border-box;
    }

    .footer-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .footer-left {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #6e6e73;
        span {
          cursor: pointer;
        }
      }

      .footer-right {
        display: flex;
        align-items: center;

        .img {
          cursor: pointer;
          width: 24px;
          height: 24px;
          margin-left: 18px;
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .footer {
    padding: 20px 0 !important;
  }
  .footer-container {
    width: 90% !important;
    .footer-title {
      font-size: 16px !important;
      padding-bottom: 8px !important;
    }
    .footer-left {
      font-size: 12px !important;
    }
    .footer-right {
      .img {
        width: 12px !important;
        height: 12px !important;
      }
    }
  }
}
</style>
